import { defineStore } from 'pinia'
import apiCall from '$/plugins/axios'

interface SubscriptionState {
  subscription: Record<string, unknown>
  credit: Record<string, unknown>
  payments: Record<string, unknown>[]
  subscriptionModal: Record<string, unknown>
}

export const useSubscriptionStore = defineStore('subscription', {
  state: (): SubscriptionState => ({
    subscription: {
      plan_slug: 'free',
    },
    credit: {},
    payments: [],
    subscriptionModal: null,
  }),

  actions: {
    async fetchSubscription() {
      const res = await apiCall.get('/subscription')
      if (res.data) {
        const { credit, ...subscriptionData } = res.data
        this.subscription = subscriptionData
        this.credit = credit
      }
      return res
    },

    async fetchPayments() {
      const res = await apiCall.get('/payments')
      this.payments = res.data
      return res
    },

    async changePlan(payload: unknown) {
      await apiCall.put('/subscriptions', { change_plan_form: payload })
    },
  },

  getters: {
    isPaidUser: (state) => state.subscription && state.subscription.plan_slug !== 'free',
    isActivePaidUser: (state) =>
      state.subscription && state.subscription.plan_slug !== 'free' && state.subscription.status === 'active',
  },
})
